<template>
  <div class="not-found-page">
    <error-text-button
      kind="default"
      title="Ops! Erro inesperado"
      text="Aconteceu algo estranho com o funcionamento do seu app, retorne para a página principal"
    >
      <template #button>
        <a-button shape="round" class="button-go-to-home" @click="goToHome()">
          Voltar para o início
        </a-button>
      </template>
    </error-text-button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

import ErrorTextButton from '@/components/Error/TextButton.vue';
import { tracking } from '@/helpers/track-event';
import { EventName } from '@/types/events';

const router = useRouter();
onMounted(() => {
  tracking.trackEvent(EventName.NotFoundPage);
});

const goToHome = () => {
  router.push(`/`);
};
</script>
<style scoped>
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.button-go-to-home {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  background-color: var(--color-contrast-oninteractive) !important;
  color: var(--color-brand-03) !important;
  border: 1px solid var(--color-brand-03) !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  height: initial;
  margin-top: 12px;
}
</style>
